<template>
  <el-tabs type="border-card" value="details" class="contacts-related-info">
    <el-tab-pane label="催记详情" name="details">
      <CollectionLog :task-id="taskId" />
    </el-tab-pane>
    <el-tab-pane label="报案记录" name="record">
      <MertCaseList :task-id="taskId" />
    </el-tab-pane>
    <!-- <el-tab-pane label="短信发送记录" name="record">
      <SMSlog :task-id="taskId" />
    </el-tab-pane> -->
  </el-tabs>
</template>

<script>
import CollectionLog from './itemCollectionLog'
import MertCaseList from './itemMertCaseList'

// import SMSlog from './SMSlog'
export default {
  name: 'Footer',
  components: {
    CollectionLog,
    MertCaseList
    // SMSlog
  },
  props: {
    taskId: {
      type: [Number, String],
      required: true
    }
  }
}
</script>
